export const MIN_ROW_HEIGHT = 120
export const MAX_ROW_HEIGHT = 700
export const DEFAULT_ROW_HEIGHT = 325
export const DEFAULT_COL_SIZE = 12
export const DEFAULT_SPLIT_SIZE = 6
export const DENSITY_WARNING_LEVEL = 0.5
export const DENSITY_ERROR_LEVEL = 0.7